import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
const defaultContext = {};
const AppActionContext = createContext(defaultContext);
export const AppActionProvider = (props) => {
    const { children, externalPostback } = props;
    const value = useMemo(() => ({
        externalPostback: externalPostback
    }), [externalPostback]);
    return (_jsx(AppActionContext.Provider, { value: value, children: children }));
};
export const useAppActionState = () => useContext(AppActionContext);
//# sourceMappingURL=AppActionContext.js.map